// extracted by css-extract-rspack-plugin
export default {"root":"qQacTPWS4wQBVEeB"};